import axios from "axios";

const consultar = (request) => {
    return axios
        .post("http://34.176.245.18:9098/api/afipprod/puc5/consultarPUC5", request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                }
            }
        );
};

const delfos = {
    consultar
};

export default delfos
